export default {
  gutter: 16,

  grids: 12,
}
